import React from 'react';

import { useIntl } from 'react-intl';

import type { ExtensionComponentProps } from '@atlassian/conversation-assistant-content-renderer/ui/message-renderer/ContentRenderer';

import { messages } from '../store-human/redacted-prompt/messages';
import { RedactedToken } from '../store-human/redacted-prompt/RedactedToken';

import { REDACT_EXTENSION_KEY, REDACT_EXTENSION_TYPE } from './constants';

/**
 * Extension component for ContentRenderer that renders scribble bars for
 * REDACT_EXTENSION_TYPE / REDACT_EXTENSION_KEY inline extension nodes.
 * Pass this as the `extensionComponent` prop to ContentRenderer.
 */
export const RedactScribbleExtension = ({
	extensionType,
	extensionKey,
	content,
}: ExtensionComponentProps): React.ReactNode => {
	const { formatMessage } = useIntl();

	if (extensionType === REDACT_EXTENSION_TYPE && extensionKey === REDACT_EXTENSION_KEY) {
		return <RedactedToken ariaLabel={formatMessage(messages.redactedAriaLabel)} delay={0} />;
	}

	return content;
};
